<template>
    <div>
        <div class="form-inline mb-3">
            <input type="text" v-model="term" class="form-control">
            <select v-model="entity" class="form-control ml-3">
                <option disabled value="">all</option>
                <option>musicArtist</option>
                <option>musicTrack</option>
                <option>album</option>
                <option>musicVideo</option>
                <option>mix</option>
                <option>song</option>
            </select>
            <select v-model="attribute" class="form-control ml-3">
                <option disabled value="">all</option>
                <option>mixTerm</option>
                <option>genreIndex</option>
                <option>artistTerm</option>
                <option>composerTerm</option>
                <option>albumTerm</option>
                <option>ratingIndex</option>
                <option>songTerm</option>
            </select>
            <!-- <span>Selected: {{ entity }}</span> -->
            <button class="btn btn-primary ml-3" @click="search">Search</button>
            <button class="btn btn-primary ml-3" @click="resetForm">Reset</button>
        </div>

        <div class="form-group">
            <ul class="list-group">
                <li class="list-group-item" v-for="item in results" v-bind:key="item.id">
                    <textarea v-text="item" class="form-control" rows="10"></textarea>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('iTunes Search mounted.')
        },

        data(){
            return {
                term: '',
                country: 'US',
                media: 'music', // movie, podcast, music, musicVideo, audiobook, shortFilm, tvShow, software, ebook, all 
                entity: '', // musicArtist, musicTrack, album, musicVideo, mix, song
                attribute: '', // mixTerm, genreIndex, artistTerm, composerTerm, albumTerm, ratingIndex, songTerm 
                results: [],
            }
        },

        computed: {

          searchURL(){
              let url = 'https://itunes.apple.com/search?term=' + this.term;
              if(this.entity != ''){
                  url = url + '&entity=' + this.entity;
              }
              if(this.attribute != ''){
                  url = url + '&attribute=' + this.attribute;
              }
              return encodeURI(url).replace(/%20/g,"+");
          },

        },


        methods: {

            resetForm(){
                this.term = '';
                this.entity = '';
                this.attribute= '';
            },

            search(){
                let vm = this;
                axios.get(this.searchURL)
                .then(function (response) {
                    console.log(response.data.results[0]);
                    vm.results = response.data.results;
                })
                .catch(function (error) {
                    console.log(error);
                });
           },

        }

}



    
</script>
